import React, { useEffect, useState } from "react";
import {
  Col,
  Container,
  Image,
  Row,
  Dropdown,
  Button,
  Spinner,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import BreadcrumbSection from "components/BreadcrumbSection";
import IMAGES from "constants/images";
import { Icon } from "@iconify/react";
import ProductTwoComponent from "components/ProductTwoComponent";
import { getOtherProfileDetails } from "api/authService";
import { useAuth } from "context/UserContext";
import { checkFollowStatus, followUser } from "api/ActivityService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Sentry } from "react-activity";
import AllProductComponent from "components/AllProductComponent";
import Loader from "components/Loader";
const sortOptions = ["Most Recent", "Weekly", "Monthly", "Yearly"];

const SortDropdown = ({ selectedOption, setSelectedOption }) => (
  <Dropdown align="start">
    <Dropdown.Toggle
      variant="light"
      className="d-flex align-items-center rounded-pill px-3"
    >
      <Icon icon="solar:sort-linear" fontSize={19} className="me-2" />
      <span className="iconFull">{selectedOption}</span>
    </Dropdown.Toggle>

    <Dropdown.Menu>
      {sortOptions.map((option, index) => (
        <Dropdown.Item key={index} onClick={() => setSelectedOption(option)}>
          {option}
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

const ProfilePublic = () => {
  const { id } = useParams();
  const { isLoggedIn, user } = useAuth();
  const userId = user ? user._id : "";
  const [followStatus, setFollowStatus] = useState("Follow");
  const [profile, setProfile] = useState(null);
  const [selectedOption, setSelectedOption] = useState(sortOptions[0]);
  const [loading, setLoading] = useState(true);
  const [followLoading, setFollowLoading] = useState(false);
  const [pageLoading, setPageLoading] = useState(true);
  const navigate = useNavigate();
  const checkFollow = async () => {
    if (!userId || !id || userId === id) return;

    try {
      const res = await checkFollowStatus(userId, id);
      if (res.success && res.body) {
        setFollowStatus(res.body.toLowerCase()); // Ensure lowercase
      }
    } catch (error) {
      console.error("Error checking follow status:", error);
      navigate("/not-found");
    }
  };

  const fetchProfileData = async () => {
    try {
      // setLoading(true);
      const [profileRes] = await Promise.all([getOtherProfileDetails(id)]);
      // setProfile(profileRes.body);
      if (profileRes.success && profileRes.body) {
        if (userId && id) checkFollow();
        setProfile(profileRes.body);
        setPageLoading(false);
      } else {
        navigate(-1);
      }
      // ✅ call after declared
    } catch (err) {
      console.error("Failed to load public profile:", err);
      navigate(-1);
    }
  };

  useEffect(() => {
    if (id) fetchProfileData();
  }, [id]);

  useEffect(() => {
    if (userId && id) checkFollow(); // ✅ safe to use now
  }, [userId, id]);

  const handleFollowToggle = async () => {
    if (!isLoggedIn) {
      toast.error("Please login to follow.");
      return;
    }

    try {
      setFollowLoading(true);
      const res = await followUser(id);
      if (res.success) {
        await checkFollow();
        fetchProfileData();
      }
    } catch (error) {
      console.error("Follow error:", error);
      toast.error("Failed to update follow status.");
    } finally {
      setFollowLoading(false);
    }
  };

  if (pageLoading) {
    return (
      <div className="loaderdiv">
        {/* <Sentry color="#e91515" size={40} speed={1} animating={true} /> */}
        <Loader />
      </div>
    );
  }
  return (
    <React.Fragment>
      <BreadcrumbSection
        breadcrumbs={[
          { title: "Public Profile", link: `/public-profile/${id}` },
          { title: `${profile?.firstName} ${profile?.lastName}` },
        ]}
      />

      <section className="software_section py-5">
      <div className="software_header  mb-3 header_profile2 d-flex  justify-content-between ps-3">
          <div className="d-flex align-items-center">
      <Icon icon="mdi:arrow-left" style={{fontSize: "24px"}} className="me-4" onClick={() => navigate(-1)}/>
      <h3 className="mb-0">{profile?.firstName} {profile?.lastName} Profile</h3>
      </div>  
      </div>
        <Container>
          <div className='public_profile_container w-100'>
            {/* Sidebar */}
            <div className="public_profile_left"
             
            >
              <div className="profile-sidebar mb20">
                <div className="profile-sidebar-image">
                  <Image
                    src={profile?.profileUrl || IMAGES.User2_Img}
                    roundedCircle
                  />
                  <div className="">
                    <h3>{profile?.followersCount || 0}</h3>
                    <p>Followers</p>
                  </div>
                  <div className="">
                    <h3>{profile?.followingCount || 0}</h3>
                    <p>Following</p>
                  </div>
                </div>

                <div className="profile-sidebar-content mb-3">
                  <div>
                    <h5>
                      {profile?.firstName} {profile?.lastName}
                    </h5>
                    <p className="text-muted mb-0">{profile?.email}</p>
                  </div>
                  {(!user || userId !== id) && (
                    <Button
                      className="border-radius-100"
                      disabled={followLoading}
                      onClick={handleFollowToggle}
                      variant={
                        followStatus === "unfollow"
                          ? "danger"
                          : followStatus === "followback"
                          ? "outline-primary"
                          : "info"
                      }
                    >
                      {followLoading ? (
                        <Spinner animation="border" size="sm" />
                      ) : followStatus === "unfollow" ? (
                        "Unfollow"
                      ) : followStatus === "followback" ? (
                        "Follow Back"
                      ) : (
                        "Follow"
                      )}
                    </Button>
                  )}
                </div>
                {(profile?.twitterProfileUrl ||
                  profile?.linkedInProfileUrl) && (
                  <div>
                    <p
                      style={{
                        fontFamily: "Inter",
                        fontWeight: "700",
                        fontSize: "15px",
                        lineHeight: "20px",
                        letterSpacing: "0px",
                        verticalAlign: "middle",
                        color: "#000000",
                      }}
                    >
                      <strong>Social Link</strong>s
                    </p>
                    <div className="d-flex gap-3">
                      {profile?.twitterProfileUrl && (
                        <a
                          href={profile.twitterProfileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-link"
                        >
                          <Image src={IMAGES.twitter} />
                        </a>
                      )}
                      {profile?.linkedInProfileUrl && (
                        <a
                          href={profile.linkedInProfileUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="social-link"
                        >
                          <Image src={IMAGES.linkedin} />
                        </a>
                      )}
                    </div>
                  </div>
                )}

                {profile?.role === "vendor" && (
                  <>
                    {profile?.badges?.length > 0 && (
                      <>
                        <div className="profile-sidebar-content mt-3 mb-3">
                          <h5>Badges ({profile.badges.length})</h5>
                        </div>
                        <div className="bagde_List">
                          {profile.badges.map(({ _id, badgeId }) => (
                            <div
                              key={_id}
                              className="badge-icon"
                              style={{ backgroundColor: badgeId.colorCode }}
                            >
                              <Image
                                src={badgeId.icon || IMAGES.Badgecolor1_IMG}
                                alt="Badge icon"
                                style={{
                                  height: "21px",
                                  width: "21px",
                                  objectFit: "contain",
                                }}
                              />
                            </div>
                          ))}
                        </div>
                      </>
                    )}
                  </>
                )}
                <div className="divider"></div>
                <h3 className="profile-statsH3">Profile Stats</h3>
                {profile?.role === "user" && (
                  <div className="profile-stats">
                    <div
                      className="profile-stats-item"
                      style={{ backgroundColor: "#FFF6DB" }}
                    >
                      <Icon
                        icon="material-symbols-light:reviews-outline"
                        fontSize={27}
                        color="#000"
                      />
                      <h5>{profile?.totalReviews || 0}</h5>
                      <p>Reviews Written</p>
                    </div>
                    <div
                      className="profile-stats-item"
                      style={{ backgroundColor: "#FFE3E3" }}
                    >
                      <Icon
                        icon="proicons:chat-question"
                        fontSize={27}
                        color="#000"
                      />
                      <h5>{profile?.totalDispute || 0}</h5>
                      <p>Dispute</p>
                    </div>
                  </div>
                )}

                {profile?.role === "vendor" && (
                  <div className="profile-stats">
                    <div
                      className="profile-stats-item"
                      style={{
                        backgroundColor: "#FFF6DB",
                      }}
                    >
                      <Icon
                        icon="carbon:container-software"
                        fontSize={27}
                        color="#000000"
                      />
                      <h5>{profile?.totalProducts || 0}</h5>
                      <p>Products</p>
                    </div>
                    <div
                      className="profile-stats-item"
                      style={{
                        backgroundColor: "#FFE3E3",
                      }}
                    >
                      <Icon
                        icon="proicons:chat-question"
                        fontSize={27}
                        color="#000000"
                      />
                      <h5>{profile?.totalDispute || 0}</h5>
                      <p>Dispute</p>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* My Reviews */}
            {profile?.role === "user" && (
              <div className="public_profile_right" style={{ width:  '100%'}}>
                <div className="right_profile_style">
                  <div className="profile_details_style mb-3">
                    <h3 className="mb-0">Recent Reviews</h3>
                    {/* <SortDropdown selectedOption={selectedOption} setSelectedOption={setSelectedOption} /> */}
                  </div>
                  <ProductTwoComponent userId={id} />
                </div>
              </div>
            )}
            {profile?.role === "vendor" && (
              <div className="public_profile_right" style={{ width: "100%" }}>
                <div className="right_profile_style">
                  <div className="profile_details_style mb-4">
                    <h3 className="mb-0">Products</h3>
                    {/* <SortDropdown selectedOption={selectedOption} setSelectedOption={setSelectedOption} /> */}
                  </div>
                  {/* <ProductComponent
                      userId={user._id}
                    /> */}

                  <AllProductComponent userId={id} />
                </div>
              </div>
            )}
          </div>
        </Container>
      </section>
    </React.Fragment>
  );
};

export default ProfilePublic;
